<div class="dialog-title-header">
  <div class="title-container">
    <div class="title">
      @if (!data.hideIcon) {
        <nmfta-icon name="{{ data.icon || 'edit' | translate }}"></nmfta-icon>
      }
      <h2 [innerHTML]="data.title || 'Generic_Edit' | translate"></h2>
      @if (data?.headerActions?.length) {
        <div class="actions">
          @for (button of data.headerActions; track button.id) {
            <nmfta-button
              [id]="button.id"
              [blackText]="button.blackText"
              [color]="button.color"
              [styleType]="button.styleType"
              [leftIcon]="button.leftIcon"
              [rightIcon]="button.rightIcon"
              [iconName]="data.useMobileActions && !isDesktop ? button.iconName : ''"
              [disabled]="button.disabled"
              (buttonClick)="button.onClick()"
              [isLoading]="button.isLoading">
              <!-- Only display labels for desktop when the useMobileActions option is set -->
              @if (isDesktop || !data.useMobileActions) {
                {{ button.label || '' | translate }}
              }
            </nmfta-button>
          }
        </div>
      }
    </div>
    @if (!data.hideClose) {
      <nmfta-button [color]="'error'" styleType="text" [blackText]="true" iconName="close" (buttonClick)="onClose()">
      </nmfta-button>
    }
  </div>
  @if (data.description) {
    <div class="description-container">
      <p class="short-description">{{ data.description | translate }}</p>
    </div>
  }
</div>

<mat-dialog-content>
  @if (data.message) {
    <div class="p-4" [class.text-center]="data.centerMessage">
      {{ data.message | translate }}
    </div>
  }
  <ng-container #dynamicContent></ng-container>
</mat-dialog-content>

@if (data.actions?.length > 0) {
  <mat-dialog-actions align="start">
    <div class="dynamic-actions" [ngClass]="{ 'flex-column': leftActions.length > 0 && isDesktop }">
      @if (isDesktop && data.actionsInstructions) {
        <nmfta-alert [message]="data.actionsInstructions"></nmfta-alert>
      } @else if (data.actionsInstructions) {
        <nmfta-icon
          name="help_outline"
          [matTooltip]="data.actionsInstructions | translate"
          matTooltipPosition="above"
          [style]="{ color: '#5BD7F3' }">
        </nmfta-icon>
      }

      @if (!isDesktop && data.actions.length > 1) {
        <nmfta-button iconName="more_vert" [blackText]="true" [matMenuTriggerFor]="verticalMenuActions"></nmfta-button>
        <mat-menu #verticalMenuActions="matMenu">
          @for (action of data.actions; track action.id) {
            <button mat-menu-item (click)="action.onClick()">
              <nmfta-icon [name]="action.iconName || action.rightIcon || action.leftAction"></nmfta-icon>
              <span>{{ action.label | translate }}</span>
            </button>
          }
        </mat-menu>
      } @else {
        <ng-container *ngTemplateOutlet="desktopActions"></ng-container>
      }
    </div>
  </mat-dialog-actions>

  <ng-template #desktopActions>
    <div class="d-flex flex-row justify-content-between align-items-center"
         [ngClass]="{ 'w-100': leftActions.length > 0 }">
      @if (leftActions.length > 0) {
        <div class="actions">
          @for (button of leftActions; track button.id) {
            <nmfta-button
              [id]="button.id"
              [blackText]="button.blackText || false"
              [color]="button.color || 'accent'"
              [styleType]="button.styleType || 'contained'"
              [leftIcon]="button.leftIcon"
              [rightIcon]="button.rightIcon"
              [iconName]="button.iconName"
              [disabled]="button.disabled || false"
              (buttonClick)="button.onClick()"
              [isLoading]="button.isLoading || false">
              {{ button.label || '' | translate }}
            </nmfta-button>
          }
        </div>
      }
      <div class="actions">
        @for (button of rightActions; track button.id) {
          <nmfta-button
            [id]="button.id"
            [blackText]="button.blackText || false"
            [color]="button.color || 'accent'"
            [styleType]="button.styleType || 'contained'"
            [leftIcon]="button.leftIcon"
            [rightIcon]="button.rightIcon"
            [iconName]="button.iconName"
            [disabled]="button.disabled || false"
            (buttonClick)="button.onClick()"
            [isLoading]="button.isLoading || false">
            {{ button.label || '' | translate }}
          </nmfta-button>
        }
      </div>
    </div>
  </ng-template>
}
